import {
    useAsyncEffect,
    useEffectAfterMount,
    useNotifications,
    useQueryParamsExecute,
    useRouter,
} from "@relode/core";
import qs from "qs";

import { CandidateSearchActions } from "./candidateSearchActions";
import { initialSearchState, SearchState } from "./candidateSearchState";

export const useSearchHandlers = (
    state: SearchState,
    actions: CandidateSearchActions
) => {
    const { actions: notifications } = useNotifications();
    const { history, location } = useRouter();
    const { error } = state;

    useQueryParamsExecute(actions.search, initialSearchState.searchCriteria);

    useEffectAfterMount(() => {
        const queryString = qs.stringify(state.searchCriteria, {
            skipNulls: true,
            addQueryPrefix: true,
            sort: (a, b) => a.localeCompare(b),
        });
        if (queryString === location.search) return;
        history.push({ search: queryString });
    }, [state.searchCriteria]);

    useAsyncEffect(async () => {
        if (!error) return; // we don't close from here.  might be odd

        const message =
            error?.friendlyMessages ?? "we've encountered a problem";

        await notifications.showModal("error", "we're sorry", message, {
            callback: () => {
                actions.clearErrors();
            },
        });
    }, [error]);
};
